import React from 'react';
import { Helmet } from 'react-helmet';

import ContentWrapper from '../styles/ContentWrapper';

const Imprint = () => (
    <React.Fragment>
        <Helmet>
            <meta name='robots' content='noindex, nofollow'/>
        </Helmet>
        <div>
            <article
                about='/legal/imprint'
                typeof='schema:WebPage'
            >
                <ContentWrapper>
                <span
                    property='schema:name'
                    content='Imprint'
                    className='stolo-hidden'
                />
                    <div
                        property='schema:text'
                        className='clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__item'
                    >
                        <h2>Imprint</h2>
                        <p>
                            <br />
                            <br />
                            Becker &amp; Karsten UG (haftungsbeschränkt)
                            <br />
                            Sandhauser Strasse 107
                            <br />
                            13505 Berlin
                            <br />
                            (not a retail store)
                            <br />
                            <br />
                            <a href='mailto: wir@stoff.love'>wir@stoff.love</a>
                            <br />
                            <br />
                            Phone: +49 30 609851965
                            <br />
                            <br />
                            represented by:
                            <br />
                            Olaf Karsten (Managing Director)
                            <br />
                            Sandhauser Strasse 107
                            <br />
                            13505 Berlin
                            <br />
                            <br />
                            <a href='mailto: wir@stoff.love'>wir@stoff.love</a>
                            <br />
                            <br />
                            Phone: (030) 609851965
                        </p>

                        <p>
                            Responsible for data protection:
                            <br />
                            Olaf Karsten
                            <br />
                            Address as above
                            <br />
                            <br />
                            Email:
                            {' '}
                            <a
                                className='buk-mail'
                                href='mailto:datenschutz@beckerundkarsten.de'
                            >
                                datenschutz@beckerundkarsten.de
                            </a>
                        </p>

                        <p>
                            <a href='/legal/privacy'>Our privacy policy.</a>
                        </p>

                        <p>
                            Email:&nbsp;
                            <a href='mailto: wir@stoff.love'>wir@stoff.love</a>
                            <br />
                            <br />
                            Registry court: Berlin Charlottenburg
                            <br />
                            Registration number: HRB 120030
                            <br />
                            VAT identification number pursuant to §27a Umsatzsteuergesetz:
                            <br />
                            VAT ID: DE265138737
                            <br />
                            <br />
                            Responsible party within the meaning of &sect; 18 Abs. 2 MStV:<br />
                            Olaf Karsten, Standhauser Str. 107, 13505 Berlin<br />
                            <br />
                            Competent supervisory authority for the provision of audiovisual media services:<br />
                            Medienanstalt Berlin-Brandenburg (mabb), Kleine Pr&auml;sidentenstra&szlig;e 1, 10178 Berlin, Germany<br />
                            <br />
                            We are neither obliged nor willing to participate in dispute resolution proceedings before a consumer arbitration board.<br />
                            <br />
                        </p>
                    </div>
                </ContentWrapper>
            </article>
        </div>
    </React.Fragment>
);

export default Imprint;



// WEBPACK FOOTER //
// ./src/components/en/Imprint.js